import { Button as GddsButton, Icon } from '@geberit/gdds';
import React from 'react';

// styles
import styles from './voucher-control.module.scss';

// types
import type { VoucherFormProps } from 'components/voucher-form/voucher-display';

// utils
import { useXy } from 'utils/hooks/use-xy';

type VoucherControlProps = Pick<VoucherFormProps, 'displayOnly' | 'removeVoucher'> & {
  appliedVoucher: string;
};

export const VoucherControl: React.FC<VoucherControlProps> = (props) => {
  const isXy = useXy();

  return (
    <div className={styles.voucherControl}>
      <p>{props.appliedVoucher}</p>
      {!props.displayOnly && (
        isXy ? (
          <>
            <GddsButton
              onClick={props.removeVoucher}
            >
              <Icon symbol="trash" width="20px" />
            </GddsButton>
          </>
        ):(
          <>
            <button onClick={props.removeVoucher}>
              <Icon symbol="trash" width="20px" />
            </button>
          </>
        )
      )}
    </div>
  );
};
